import { Div } from "atomize/dist"
import PlayersContainer from "../PlayersContainer"

const Players = () => {
	return (
		<Div>
			<PlayersContainer />
			<Div h="10.75rem" pos="relative" />
		</Div>
	)
}

export default Players
